import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Card, CardBody, Label, FormGroup, Fade } from 'reactstrap';
import { Row, Col, PageHeader, Input, Spin, Select, DatePicker, Button, Modal } from 'antd';
import { urlapi, token, CheckTokenExp } from '../../config';
import TemplateName from '../Dropdown/TemplateName';
import StatusType from '../Dropdown/StatusType';
import StatusSend from '../Dropdown/StatusSend';
import StatusFailover from '../Dropdown/StatusFailover';
import StatusSMS from '../Dropdown/StatusSMS';
import ModalSuccess from '../../components/Ants/Modal/ModalSuccess';
import ModalWarning from '../../components/Ants/Modal/ModalWarning';
import moment from 'moment';

const dateFormat = 'DD/MM/YYYY';
const dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';

class CreateReport extends Component {
    constructor(props) {
        super(props);

        this.onSave = this.onSave.bind(this);
        this.setParamColumn = this.setParamColumn.bind(this);
        this.onChangeinput = this.onChangeinput.bind(this);
        this.onChangedate = this.onChangedate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.warningModal = this.warningModal.bind(this);
        this.successModal = this.successModal.bind(this);
        this.modalcountDown = this.modalcountDown.bind(this);

        this.state = {
            warningModalVisible: false,
            successModalVisible: false,
            loading: false,
            message: "",
            messageSuccess: "",
            RPT_NAME: "",
            RPT_FORM_DATE: "",
            RPT_TO_DATE: "",
            RPT_TEMPLATE: "",
            RPT_GROUPCODE1: "",
            RPT_GROUPCODE2: "",
            RPT_TRANTYPE: "",
            RPT_SENDSTATUS: "",
            RPT_FAILOVERSTATUS: "",
            RPT_SMSSTATUS: 0,
            RPT_PARAMETER: "",
            RPT_COLUMN: "",
            RPT_CREATE_DATE: "",
            RPT_UPDATE_DATE: "",
            RPT_STATUS: "",
        }
    }

    componentDidMount() {

    }

    onSave() {
        if (!CheckTokenExp()) {
            this.setState({ loading: true });
            let req = JSON.stringify({
                RPT_NAME: this.state.RPT_NAME,
                RPT_FORM_DATE: this.state.RPT_FORM_DATE,
                RPT_TO_DATE: this.state.RPT_TO_DATE,
                RPT_TEMPLATE: this.state.RPT_TEMPLATE,
                RPT_GROUPCODE1: this.state.RPT_GROUPCODE1,
                RPT_GROUPCODE2: this.state.RPT_GROUPCODE2,
                // RPT_TRANTYPE: this.state.RPT_TRANTYPE,
                RPT_SENDSTATUS: this.state.RPT_SENDSTATUS === "" ? 0 : this.state.RPT_SENDSTATUS,
                RPT_FAILOVERSTATUS: this.state.RPT_FAILOVERSTATUS,
                RPT_SMSSTATUS: this.state.RPT_SMSSTATUS === "" ? 0 : this.state.RPT_SMSSTATUS,
                RPT_PARAMETER: this.state.RPT_PARAMETER,
                RPT_COLUMN: this.state.RPT_COLUMN
            });

            fetch(urlapi + "api/savereport", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        this.setState({ loading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    setParamColumn() {
        // let parameter = this.state.RPT_NAME.trim() + "|" + this.state.RPT_FORM_DATE + "|" + this.state.RPT_TO_DATE + "|" + this.state.RPT_TEMPLATE + "|" +
        //     this.state.RPT_GROUPCODE1.trim() + "|" + this.state.RPT_GROUPCODE2.trim() + "|" + [this.state.RPT_TRANTYPE] + "|" +
        //     this.state.RPT_SENDSTATUS + "|" + this.state.RPT_FAILOVERSTATUS + "|" + this.state.RPT_SMSSTATUS;

        let parameter = this.state.RPT_NAME.trim() + "|" + this.state.RPT_FORM_DATE + "|" + this.state.RPT_TO_DATE + "|" + this.state.RPT_TEMPLATE + "|" +
            this.state.RPT_GROUPCODE1.trim() + "|" + this.state.RPT_GROUPCODE2.trim() + "|" + this.state.RPT_SENDSTATUS + "|" +
            this.state.RPT_FAILOVERSTATUS + "|" + this.state.RPT_SMSSTATUS;

        // let column = "RPT_NAME|FORM_DATE|TO_DATE|RPT_TEMPLATE|RPT_GROUPCODE1|RPT_GROUPCODE2|RPT_TRANTYPE|RPT_SENDSTATUS|RPT_FAILOVERSTATUS|RPT_SMSSTATUS|ACCOUNT";
        let column = "RPT_NAME|FORM_DATE|TO_DATE|RPT_TEMPLATE|RPT_GROUPCODE1|RPT_GROUPCODE2|RPT_SENDSTATUS|RPT_FAILOVERSTATUS|RPT_SMSSTATUS|ACCOUNT";

        this.setState({
            RPT_PARAMETER: parameter,
            RPT_COLUMN: column,
        })

        setTimeout(() => {
            this.onSave()
        }, 10)
    }

    onChangeinput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangedate(date, dateString) {
        this.setState({ RPT_FORM_DATE: dateString[0], RPT_TO_DATE: dateString[1] });
    }

    onCancel() {
        this.props.history.push("/report/");
    }

    warningModal(value, message, messageSuccess) {
        this.setState({ warningModalVisible: value, message, messageSuccess });

        let modalcontent = document.querySelectorAll('.ant-modal-contentant-modal-content-hide');
        for (var i = 0; i < modalcontent.length; i++) {
            modalcontent[i].className = "ant-modal-content";
        }
    }

    successModal(value) {
        if (this.state.action == "create") {
            this.setParamColumn();
            this.setState({ action: "" });
        }

        if (this.state.action == "discard") {
            this.props.history.push('/report/');
            value = false;
            this.setState({ action: "" });
        }

        this.setState({ successModalVisible: value });
        let modalcontent = document.querySelectorAll('.ant-modal-contentant-modal-content-hide');
        for (var i = 0; i < modalcontent.length; i++) {
            modalcontent[i].className = "ant-modal-content";
        }
    }

    modalcountDown() {
        let secondsToGo = 2;
        this.setState(state => {
            if (state.successModalVisible) {
                setTimeout(() => {
                    this.setState({ successModalVisible: false });
                    this.props.history.push('/report/');
                }, secondsToGo * 1000);
            }
        });

    }

    render() {
        const { message, messageSuccess, warningModalVisible, successModalVisible, loading } = this.state;
        const { Option } = Select;
        const { RangePicker } = DatePicker;
        const routes = [
            {
                path: '/report/',
                breadcrumbName: 'Report',
            },
            {
                breadcrumbName: 'Create',
            },
        ];
        return (
            <div>
                <PageHeader breadcrumb={{ routes }}>
                </PageHeader>

                <div className="content">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Fade in={this.state.fadeIn}>
                            <Card>
                                <CardBody>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label className="require" htmlFor="RPT_NAME">
                                                    Report Name
                                                </Label>
                                                <Input
                                                    placeholder="Report Name"
                                                    name="RPT_NAME"
                                                    onChange={this.onChangeinput}
                                                    value={this.state.RPT_NAME}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label className="require" htmlFor="rptDateRange">
                                                    Date Range
                                                </Label>
                                                <RangePicker
                                                    style={{ width: "100%" }}
                                                    format={dateFormat}
                                                    suffixIcon={<span className="fa fa-calendar-o" />}
                                                    onChange={this.onChangedate}
                                                    ranges={{
                                                        Today: [moment().startOf('day'), moment().endOf('day')],
                                                        'Last 7 days': [moment().subtract(6, 'd'), moment()],
                                                        'Last week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                                                        'Last 15 days': [moment().subtract(14, 'd'), moment()],
                                                        'Last 30 days': [moment().subtract(29, 'd'), moment()],
                                                        'This month': [moment().startOf('month'), moment().endOf('month')]
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_TEMPLATE">
                                                    Template Name
                                                </Label>
                                                <TemplateName
                                                    onchange={(e) =>
                                                        this.setState({ RPT_TEMPLATE: e })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_GROUPCODE1">
                                                    Group Code 1
                                                </Label>
                                                <Input
                                                    placeholder="Report Name"
                                                    name="RPT_GROUPCODE1"
                                                    onChange={this.onChangeinput}
                                                    value={this.state.RPT_GROUPCODE1}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_GROUPCODE2">
                                                    Group Code 2
                                                </Label>
                                                <Input
                                                    placeholder="Report Name"
                                                    name="RPT_GROUPCODE2"
                                                    onChange={this.onChangeinput}
                                                    value={this.state.RPT_GROUPCODE2}
                                                />
                                            </FormGroup>
                                        </Col>
                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_TRANTYPE">
                                                    Type
                                                </Label>
                                                <StatusType
                                                    onchange={(e) =>
                                                        this.setState({ RPT_TRANTYPE: e })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col> */}

                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_SENDSTATUS">
                                                    Status
                                                </Label>
                                                <StatusSend
                                                    onchange={(e) =>
                                                        this.setState({ RPT_SENDSTATUS: e })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_FAILOVERSTATUS">
                                                    Failover Status
                                                </Label>
                                                <StatusFailover
                                                    onchange={(e) =>
                                                        this.setState({ RPT_FAILOVERSTATUS: e })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <FormGroup>
                                                <Label htmlFor="RPT_SMSSTATUS">
                                                    SMS Status
                                                </Label>
                                                <StatusSMS
                                                    onchange={(e) =>
                                                        this.setState({ RPT_SMSSTATUS: e })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 20 }} gutter={16}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={4}></Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={20}>
                                            <Row gutter={16} type="flex" justify="end">
                                                <Col xs={24} sm={24} md={24} lg={24} xl={6}></Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={8}></Col>
                                                <Col style={{ textAlign: 'right' }}>
                                                    <Button key="submit" style={{ marginRight: 8 }}
                                                        onClick={() => { this.setState({ action: "discard" }), this.warningModal(true, "Do you want to discard change?", "Discarded change successfully.") }}>
                                                        <span className="fa fa-trash-o"></span> &nbsp;&nbsp;
                                                        Discard
                                                    </Button>
                                                </Col>
                                                <Col style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ marginRight: 8 }}
                                                        disabled={this.state.RPT_NAME !== "" && this.state.RPT_FORM_DATE !== "" ? false : true}
                                                        onClick={() => {
                                                            this.setState({ action: "create" }),
                                                                this.warningModal(true, "Do you want to create this report?", "Created report successfully.")
                                                        }}
                                                    >
                                                        <span className="fa fa-plus-circle"></span> &nbsp;&nbsp;
                                                        Create
                                                    </Button>
                                                </Col>
                                            </Row>

                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Fade>
                    </Col>
                </div>

                <ModalWarning loading={loading}
                    warningModalVisible={warningModalVisible}
                    warningModal={this.warningModal}
                    successModal={this.successModal}
                    modalcountDown={this.modalcountDown}
                    message={message}
                    messageSuccess={messageSuccess}
                />

                <ModalSuccess loading={loading}
                    successModalVisible={successModalVisible}
                    successModal={this.successModal}
                    messageSuccess={messageSuccess}
                />

            </div>

        );
    }
}

export default CreateReport;



// WEBPACK FOOTER //
// ./src/views/Report/CreateReport.js